import { gql } from '@apollo/client';
import price from '../../../gqlCommon/graphql/fragments/price';
import baseImage from '../../../gqlCommon/graphql/fragments/baseImage';

const featureChildren = {
  GET_FEATURE_CHILDREN: gql`
    ${baseImage.BASE_IMAGE}
    ${price.PRICE}
    query GetFeatureChildren($featureCode: String!, $carCode: String!, $postCode: String) {
      featureChildren(featureCode: $featureCode, carCode: $carCode, postCode: $postCode) {
        label
        code
        images {
          ...BaseImage
        }
        longDescription
        shortDescription
        prices {
          ...Price
        }
      }
    }
  `,
};

export default featureChildren;
